module.exports = __webpack_public_path__ + "img/idcard1.5fd0d547.png";